import { getPositionsBatch } from "@/api/position";
import { H8Bold, PositionChip, px2rem, SkeletonBox } from "@moim/common";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { SectionTitle } from "../../styledComponent";
import { PositionEmpty } from "../empty";
import { Wrapper, PositionContainer, PositionCell } from "./styledComponents";

const PositionItem: React.FC<{
  position: Moim.Position.IPosition;
  onClick: React.MouseEventHandler<HTMLSpanElement>;
}> = ({ position, onClick }) => {
  return (
    <PositionCell onClick={onClick}>
      <PositionChip
        id={position.id}
        name={position.name}
        size="medium"
        color={position.color}
        maxContentWidth={270}
        onClick={onClick}
      />
    </PositionCell>
  );
};
interface IProps {
  positions: Moim.Id[] | undefined;
}

const Positions: React.FC<IProps> = ({ positions: positionIds }) => {
  const [positions, setPositions] = React.useState<Moim.Position.IPosition[]>(
    [],
  );
  const handleClickPosition: React.MouseEventHandler<HTMLSpanElement> =
    React.useCallback(() => {}, []);

  React.useEffect(() => {
    getPositionsBatch(positionIds).then(result => {
      setPositions(result);
    });
  }, [positionIds]);

  const elements = React.useMemo(() => {
    if (positions !== undefined && positions?.length === 0) {
      return <PositionEmpty />;
    }

    if (
      positions === undefined ||
      positions?.every(position => position === undefined)
    ) {
      return (
        <>
          <PositionCell key={"position_skeleton_1"}>
            <SkeletonBox width={px2rem(59)} height={px2rem(21)} />
          </PositionCell>
          <PositionCell key={"position_skeleton_2"}>
            <SkeletonBox width={px2rem(145)} height={px2rem(21)} />
          </PositionCell>
          <PositionCell key={"position_skeleton_3"}>
            <SkeletonBox width={px2rem(72)} height={px2rem(21)} />
          </PositionCell>
        </>
      );
    }

    return positions
      ?.filter(item => Boolean(item))
      .map(position => (
        <PositionItem
          key={position.id}
          data-position-id={position.id}
          position={position}
          onClick={handleClickPosition}
        />
      ));
  }, [handleClickPosition, positions]);

  return (
    <>
      <SectionTitle>
        <H8Bold>
          <FormattedMessage id="profile_show/position_title" />
        </H8Bold>
      </SectionTitle>
      <Wrapper>
        <PositionContainer>{elements}</PositionContainer>
      </Wrapper>
    </>
  );
};

export default Positions;
